import { queryKeys } from '@/utils/constants';
import type { ApiAgentsListParams } from '@/types/agents';

const MODULE_KEY = 'agents';

export const getAgentsQueryKey = (orgTwrn?: string | null, params?: ApiAgentsListParams) => {
  const key: (string | ApiAgentsListParams)[] = [MODULE_KEY, queryKeys.AGENTS];

  if (orgTwrn) {
    key.push(orgTwrn);
  }

  if (params) {
    if (!orgTwrn) {
      console.warn(
        '[getAgentsQueryKey] params were provided without orgTwrn. orgTwrn is required when params are passed.',
        {
          orgTwrn,
          params,
        },
      );
      return key;
    }
    key.push(params);
  }

  return key;
};

export const getAgentsByAthletesQueryKey = (athleteTwrns?: string[]) => {
  const key: (string | string[])[] = [MODULE_KEY, queryKeys.AGENTS_BY_ATHLETE];

  if (athleteTwrns && athleteTwrns.length > 0) {
    key.push([...athleteTwrns].sort());
  }

  return key;
};
